import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ProjectFormLayout from "layouts/ProjectFormLayout";
import themeProps from "theme/themes";
import galleryAdd from "assets/icons/gallery_add.svg";
import { ChangeEvent } from "react";
import { ProjectDto } from "common/dtos/ProjectDto";

interface ProjectPhotoProps {
  projectData: ProjectDto;
  setProjectData: any;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid ${(state: themeProps) => state.theme.border.secondary};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadIconWrapper = styled.div`
  width: 6vw;
  max-width: 80px;
  height: 6vw;
  max-height: 80px;
  border-radius: 50%;
  position: relative;
`;

const UploadIcon = styled.button`
  width: 6vw;
  max-width: 80px;
  height: 6vw;
  max-height: 80px;
  border-radius: 50%;
  border: none;
  outline: none;
  background-color: ${(state: themeProps) => state.theme.main.primary};
  padding: 20px;
  position: absolute;
  top: 0;
  left: 0;
`;

const Icon = styled.img`
  width: 100%;
`;

const Input = styled.input`
  display: none;
`;

const Label = styled.label`
  width: 6vw;
  max-width: 80px;
  height: 6vw;
  max-height: 80px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
  background-color: #b1b1b1;
  :hover {
    border: 3px solid gray;
    opacity: 0.2;
  }
`;

const ProjectPhoto = ({ projectData, setProjectData }: ProjectPhotoProps) => {
  const { t } = useTranslation("project");

  const onPictureChange = (e: ChangeEvent) => {
    // const input = e.target as HTMLInputElement;
    // if (!input.files?.length) return;
    // const img = input.files[0];
    // setProjectData({
    //   ...projectData,
    //   picture: URL.createObjectURL(img),
    // });
  };

  return (
    <ProjectFormLayout title={t("addPhoto")}>
      <Wrapper>
        <UploadIconWrapper>
          <UploadIcon>
            <Icon src={galleryAdd} />
          </UploadIcon>
          <Label>
            <Input type="file" onChange={onPictureChange} />
          </Label>
        </UploadIconWrapper>
      </Wrapper>
    </ProjectFormLayout>
  );
};

export default ProjectPhoto;
